import React from 'react';
import { Card } from 'react-bootstrap';
import '../styles/Work.css';

export default function Work({ image, name, url, technologies, type }) {
    return (
        <div className="col-lg-4 col-md-6 col-sm-12 col-12">
            <a target="_blank" rel="noreferrer noopener" href={url} style={{ textDecoration: 'none', cursor: 'pointer' }}>
                <Card className='work-card' style={{ margin: '10px 0px', minHeight: '400px' }}>
                    <Card.Img variant="top" src={image} />
                    <Card.Body className='text-center' style={{ color: '#000' }}>
                        <h5 style={{ marginBottom: '-5px' }}>{name}</h5>
                        <small>{type}</small><br />
                        <div className="mt-3">
                            {
                                technologies.map(tech => <div key={Math.random()} className="tech">{tech}</div>)
                            }
                        </div>
                    </Card.Body>
                </Card>
            </a>
        </div>
    );
};